import React from "react";

export const Projects = (props) => {
  return (
    <div id="projects">
      <div className="container">
        <div className="section-title text-center">
          <h2>Projects</h2>
          <p>A selection of projects I've worked on.</p>
        </div>

        <div className="row">
          {props.data
            ? props.data.map((project, i) => (
                <div
                  key={`${project.title}-${i}`}
                  className="col-xs-12 col-md-4"
                >
                  <div className="project-card">
                    <h3>{project.title}</h3>

                    <p>{project.description}</p>

                    <div className="project-tech">
                      {project.technologies}
                    </div>

                    {project.github && (
                        <a
                        href={project.github}
                        target="_blank"
                        rel="noopener noreferrer"
                        >
                        View on GitHub →
                        </a>
                    )}
                  </div>
                </div>
              ))
            : "Loading..."}
        </div>
      </div>
    </div>
  );
};